module.exports = __webpack_public_path__ + "static/media/IconModalAcessoSair.28336d21.svg";